<div class="mobile-dialog">
  <div class="container" style="background-color: #c8c8d2; height: 35px">
    <h1 style="color: black; font-weight: 400">Select Mobile</h1>
  </div>
  <form [formGroup]="mobileForm" (ngSubmit)="onSubmit()">
    <div
      class="md-dialog-content user-role-dialog-content"
      style="padding: 20px"
    >
      <div>
        <label for="">Account<span class="text-danger"> *</span></label>
        <select
          class="form-select"
          formControlName="account"
          disabled
          style="width: 95%; height: 40px"
        >
          <option>{{ data.account }}</option>
        </select>
      </div>

      <div class="mt-3">
        <label for="">Mobile <span class="text-danger"> *</span></label>
        <ng-select
          [items]="data.mobiles"
          required
          bindLabel="name"
          [(ngModel)]="selectedMobile"
          class="form-control1 mobile-dropdown"
          formControlName="mobiles"
          appendTo="body"
          placeholder="-Select Mobile-"
          style="width: 95%"
          [editableSearchTerm]="true"
        >
        </ng-select>
        <span
          *ngIf="mobiles && mobiles.invalid && mobiles.touched"
          class="text-danger"
          >Mobile is required
        </span>
      </div>
      <button
        class="proceed prim-button-link"
        type="submit"
        (click)="onNoClick()"
      >
        PROCEED
      </button>
    </div>
  </form>
</div>
